import { render, staticRenderFns } from "./headerimage.vue?vue&type=template&id=87bf4b44&scoped=true&%3Ais=view&"
import script from "./headerimage.vue?vue&type=script&lang=js&"
export * from "./headerimage.vue?vue&type=script&lang=js&"
import style0 from "./headerimage.vue?vue&type=style&index=0&id=87bf4b44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bf4b44",
  null
  
)

export default component.exports